import { TransactionDTO } from "../generated/api";

export function filterTransactions(
  transactionsToFilter: TransactionDTO[] | undefined,
  careProviderId: string
) {
  let transactions: TransactionDTO[] = [];
  if (transactionsToFilter) {
    for (let i = 0; i < transactionsToFilter.length; i++) {
      if (
        transactionsToFilter[i].registeringCareProviderId === careProviderId
      ) {
        transactions.push(transactionsToFilter[i]);
      }
    }
  }

  return transactions;
}
